import React from 'react';
import "./TopBar.sass";
import placeholder from "../../../assets/placeholder.jpg";
import {FiMoreVertical, FiArrowLeft, FiMoreHorizontal, FiExternalLink, FiTablet} from 'react-icons/fi';
import {useGlobal} from "reactn";
import Config from "../../../config";

const TopBar = ({back}) => {
    return (
            <div className="top-bar uk-flex uk-flex-between uk-flex-middle">
                <div className="nav">
                    <div className="button" onClick={back}>
                        <FiArrowLeft/>
                    </div>
                </div>
                <div className="nav">
                    {Config.demo && <div className="uk-inline">
                        <div className="button" type="button">
                            <FiMoreHorizontal/>
                        </div>
                        {/*<div data-uk-dropdown="mode: click; offset: 5; boundary: .top-bar; pos: bottom-right">*/}
                        {/*    <div className="link" onClick={honeyside}>Honeyside <div className="icon"><FiExternalLink/></div></div>*/}
                        {/*    <div className="link" onClick={codeCanyon}>CodeCanyon <div className="icon"><FiExternalLink/></div></div>*/}
                        {/*</div>*/}
                    </div>}
                </div>
            </div>
    );
}

export default TopBar;
